/**
 * Temporary product flags (Vite env).
 * Quote Chat UI is hidden until VITE_FEATURE_QUOTE_CHAT=true.
 * Quote Distribution UI is hidden until VITE_FEATURE_QUOTE_DISTRIBUTION=true.
 */
export const isQuoteChatUiEnabled = () =>
  String(import.meta.env.VITE_FEATURE_QUOTE_CHAT || '').toLowerCase() === 'true';

export const isQuoteDistributionUiEnabled = () =>
  String(import.meta.env.VITE_FEATURE_QUOTE_DISTRIBUTION || '').toLowerCase() === 'true';
